import { render, staticRenderFns } from "./reply-refer.vue?vue&type=template&id=5a9cf18e&scoped=true&"
import script from "./reply-refer.vue?vue&type=script&lang=js&"
export * from "./reply-refer.vue?vue&type=script&lang=js&"
import style0 from "./reply-refer.vue?vue&type=style&index=0&id=5a9cf18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9cf18e",
  null
  
)

export default component.exports